/* eslint-disable jira/filename-case */

import { setBooleanFeatureFlagResolver } from '@atlaskit/platform-feature-flags/setBooleanFeatureFlagResolver';
import { fg, withoutFeatureExistenceCheck } from '@atlassian/jira-feature-gating';
import type { ResolverOverride } from '../../common/types.tsx';

/**
 * For the visual refresh, all usages of initPlatformFeatureFlags require this override. `visualRefreshResolverOverride`.
 * visualRefreshResolverOverride will be cleaned up when the platform visual refresh gates are cleaned up.
 * visualRefreshResolverOverride is required to enable the platform visual refresh gates for Jira in FedRamp.
 */
export const initPlatformFeatureFlags = ([isOverride, resolver]: ResolverOverride): void => {
	setBooleanFeatureFlagResolver((flagKey) =>
		// disable existence check as platform feature >flags< might not be gates
		withoutFeatureExistenceCheck(() => (isOverride(flagKey) ? resolver(flagKey) : fg(flagKey))),
	);
};
